<template>
  <section class="direct_debit-comp" v-if="!state.loading">
    <div style="display: flex; flex-direction: column; gap: 20px; max-width: 700px; padding: 0px 40px 50px 40px;"
      v-if="state.mode === 'all_providers'">
      <div style="display: flex; flex-direction: column; gap: 30px;">
        <p style="font-size: 20px; font-weight: 500; color: #495255;">Services & Provider</p>
        <div style="height: 1px; background-color: #E0E0E0; width: 100%;"></div>
      </div>

      <div v-for="service in services" :key="service.mode" v-if="isServiceValid(service)"
        style="display: flex; flex-direction: column; gap: 30px;">
        <div style="
              display: flex;
              gap: 20px;
              width: 100%;
              justify-content: space-between;
              align-items: center;
            ">
          <div style="
                display: flex;
                flex-direction: column;
                gap: 20px;
                width: 100%;
                justify-content: space-between;
              ">
            <p style="
                  font-size: 18px;
                  font-weight: medium;
                  color: #495255;
                ">
              {{ service.label }}
            </p>
            <div style="display: flex; gap: 4px; align-items: center;">
              <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2.5" r="2.5" :fill="getProviderColor(state[service.key].active)" />
              </svg>
              <span style="
                    font-size: 16px;
                    font-weight: 500;
                    color: #919eab;
                    line-height: 1;
                    position: relative;
                    top: 2px;
                  ">
                {{ state[service.key].active }}
              </span>
            </div>
          </div>
          <div style="
                color: #ffffff;
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
                background: #e00b5b;
                width: 81px;
                height: 34px;
                padding: 5px 10px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
              " @click="state.mode = service.mode">
            Edit
          </div>
        </div>
        <div style="height: 1px; background-color: #e0e0e0; width: 100%;"></div>
      </div>
    </div>

    <div v-if="state.mode !== 'all_providers'"
      style="display: flex; flex-direction: column; gap: 30px; max-width: 450px; padding: 20px 40px 50px 40px;">
      <div style="display: flex; flex-direction: column; justify-content: center; gap: 8px;">
        <p style="font-size: 20px; font-weight: 400; color: #4C4C4C;">{{ providerToEdit.type }}</p>
        <div class="custom-dropdown">
          <div class="custom-dropdown__trigger" :class="{ 'active': state.showDropdown }" @click="toggleDropdown">
            <span class="custom-dropdown__selected-text">{{ selectedProviderName }}</span>
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"
              :style="{ transform: state.showDropdown ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }">
              <path d="M1 1.5L6 6.5L11 1.5" stroke="#495255" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <transition name="fade-slide">
            <div v-if="state.showDropdown" class="custom-dropdown__options shadow-lg">
              <div v-for="(value, key) in providerToEdit.options" :key="key" class="custom-dropdown__option"
                :class="{ 'selected': state.selectedProviderId === value.id }" @click="selectProvider(value.id)">
                <span>{{ value.name }}</span>
                <svg v-if="state.selectedProviderId === value.id" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div
        style="display: grid;  grid-template-columns: 1fr 1fr; width: 100%; justify-content: space-between; align-items: center; gap: 8px;">
        <button
          style="height: 56px; background: #E00B5B; padding: 16px 20px; color: white; cursor: pointer; border: none; border-radius: 4px; font-weight: 500;"
          @click="state.show_confirmation_modal = true">Save Changes</button>
        <button
          style="height: 56px; background: #D8DADC; padding: 16px 20px; color: #495255; cursor: pointer; border: none; border-radius: 4px; font-weight: 500;"
          @click="revertChanges">Revert Changes</button>
      </div>
    </div>

    <div
      style="position: fixed; top: 0; right: 0; background: rgb(0 0 0 / 18%); height: 100vh; width: 100vw; z-index: 100; display: flex; justify-content: center; align-items: center;"
      v-if="state.show_confirmation_modal">
      <div
        style="background: white; border-radius: 8px; display: flex; flex-direction: column; gap: 16px; padding: 50px 30px; display: flex; justify-content: center; align-items: center;">
        <p style="font-size: 24px; color: #4C4C4C; font-weight: medium;">Save Changes</p>
        <p style="font-size: 14px; color: #6C6C6C; font-weight: medium;">Are you sure you want to change your provider?
        </p>
        <div
          style="display: grid;  grid-template-columns: 1fr 1fr; width: 100%; justify-content: space-between; align-items: center; gap: 8px; margin-top: 4px;">
          <button
            style="height: 40px; background: #E00B5B; padding: 16px 20px; color: white; cursor: pointer; border: none; border-radius: 4px; font-weight: 500; display: flex; justify-content: center; align-items: center; font-size: 14px;"
            :disabled="state.updatingProvider" @click="updateProvider">
            <span v-if="state.updatingProvider" class="btn-spinner"></span>
            <span v-if="!state.updatingProvider">Save Changes</span>
            <span v-else style="margin-left: 8px;">Saving...</span>
          </button>
          <button
            style="height: 40px; background: #D8DADC; padding: 16px 20px; color: #495255; cursor: pointer; border: none; border-radius: 4px; font-weight: 500; display: flex; justify-content: center; align-items: center; font-size: 14px;"
            :disabled="state.updatingProvider" @click="revertChanges">
            Revert Changes
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from "vue";
import { computed, onMounted, reactive, onUnmounted } from "@vue/composition-api";
export default {
  name: "BillsPaymentProviderRouting",
  setup(props, { root }) {
    const state = reactive({
      loading: true,
      updatingProvider: false,
      mode: "all_providers",
      show_confirmation_modal: false,
      selectedProviderId: null,
      services: [
        { label: "Airtime", mode: "Airtime", key: "airtime" },
        { label: "Data", mode: "Data", key: "data" },
        { label: "Electricity", mode: "Electricity", key: "electricity" },
        { label: "TV Subscription", mode: "TV Subscription", key: "tv" },
        { label: "WAEC", mode: "WAEC", key: "waec" },
        { label: "JAMB", mode: "JAMB", key: "jamb" },
      ],
      airtime: {},
      data: {},
      waec: {},
      jamb: {},
      tv: {},
      electricity: {},
      showDropdown: false,
    });
    const isServiceValid = (service) => {
      const svc = state[service.key];
      return (
        !!svc &&
        !!svc.id &&
        !!svc.active &&
        Array.isArray(svc.options) &&
        svc.options.length > 0
      );
    };
    const providerToEdit = computed(() => {
      const title = state.mode;
      let providerOptions;
      switch (state.mode) {
        case "Airtime":
          providerOptions = state.airtime.options;
          break;
        case "Data":
          providerOptions = state.data.options;
          break;
        case "Electricity":
          providerOptions = state.electricity.options;
          break;
        case "TV Subscription":
          providerOptions = state.tv.options;
          break;
        case "WAEC":
          providerOptions = state.waec.options;
          break;
        case "JAMB":
          providerOptions = state.jamb.options;
          break;
        default:
          providerOptions = [];
          break;
      }
      return { type: title, options: providerOptions }
    });
    const selectedProviderName = computed(() => {
      if (!providerToEdit.value.options) return "Select Provider";
      const selected = providerToEdit.value.options.find(
        (opt) => opt.id === state.selectedProviderId
      );
      return selected ? selected.name : "Select Provider";
    });
    const toggleDropdown = (e) => {
      e.stopPropagation();
      state.showDropdown = !state.showDropdown;
    };
    const selectProvider = (id) => {
      state.selectedProviderId = id;
      state.showDropdown = false;
    };
    const closeDropdown = () => {
      state.showDropdown = false;
    };
    const revertChanges = () => {
      state.show_confirmation_modal = false;
      state.mode = "all_providers";
    };
    const updateProvider = async () => {
      try {
        state.updatingProvider = true;
        const url = process.env.VUE_APP_BILL_URL;
        const mappedServiceType =
          state.mode === "TV Subscription" ? "SUBSCRIPTION" : state.mode;
        const payload = {
          service_type: mappedServiceType,
          provider_id: state.selectedProviderId,
        };
        const res = await Vue.http.patch(`${url}/admin/service_type`, payload);
        Vue.notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: `Successfully updated ${state.mode} provider`,
        });
      } catch (error) {
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.message ? error.message : 'Error',
        });
      } finally {
        state.updatingProvider = false;
        revertChanges();
        getConfiguration();
      }
    }
    const getConfiguration = async () => {
      try {
        state.loading = true;
        const url = process.env.VUE_APP_BILL_URL;
        const providersRes = await Vue.http.get(`${url}/admin/provider`)
        const providers = providersRes.body;
        const currentConfigurationRes = await Vue.http.get(`${url}/admin/configured_service_type`);
        const currentConfiguration = currentConfigurationRes.body;
        const airtimeInfo = currentConfiguration.find(i => i.service_type === "AIRTIME");
        const dataInfo = currentConfiguration.find(i => i.service_type === "DATA");
        const electricityInfo = currentConfiguration.find(i => i.service_type === "ELECTRICITY");
        const tvInfo = currentConfiguration.find(i => i.service_type === "SUBSCRIPTION");
        const waecInfo = currentConfiguration.find(i => i.service_type === "WAEC");
        const jambInfo = currentConfiguration.find(i => i.service_type === "JAMB");
        if (airtimeInfo && airtimeInfo.Provider && airtimeInfo.Provider.name) {
          state.airtime = {
            id: airtimeInfo.id,
            active: airtimeInfo.Provider.name,
            options: providers
          };
        }
        if (electricityInfo && electricityInfo.Provider && electricityInfo.Provider.name) {
          state.electricity = {
            id: electricityInfo.id,
            active: electricityInfo.Provider.name,
            options: providers
          };
        }
        if (tvInfo && tvInfo.Provider && tvInfo.Provider.name) {
          state.tv = {
            id: tvInfo.id,
            active: tvInfo.Provider.name,
            options: providers
          };
        }
        if (waecInfo && waecInfo.Provider && waecInfo.Provider.name) {
          state.waec = {
            id: waecInfo.id,
            active: waecInfo.Provider.name,
            options: providers
          };
        }
        if (dataInfo && dataInfo.Provider && dataInfo.Provider.name) {
          state.data = {
            id: dataInfo.id,
            active: dataInfo.Provider.name,
            options: providers
          };
        };
        if (jambInfo && jambInfo.Provider && jambInfo.Provider.name) {
          state.jamb = {
            id: jambInfo.id,
            active: jambInfo.Provider.name,
            options: providers
          }
        };
      } catch (error) {
        Vue.notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.message ? error.message : 'Error',
        });
      } finally {
        state.loading = false;
      }
    };
    const getProviderColor = (providerName) => {
      if (!providerName) return "#E00B5B";
      const name = providerName.toLowerCase();
      if (name.includes("airvend")) return "#FFCC00";
      if (name.includes("palmpay")) return "#3BBCEB";
      return "#E00B5B";
    };
    onMounted(() => {
      getConfiguration();
      window.addEventListener("click", closeDropdown);
    });
    onUnmounted(() => {
      window.removeEventListener("click", closeDropdown);
    });
    return {
      state,
      providerToEdit,
      revertChanges,
      services: state.services,
      isServiceValid,
      updateProvider,
      selectProvider,
      toggleDropdown,
      selectedProviderName,
      getProviderColor
    };
  },
};
</script>
<style lang="scss">
.direct_debit-comp {
  >div:first-child {
    padding: 0 25px 25px;
  }

  h1 {
    font-style: italic;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    color: #261940;
    margin: 10px 25px 50px;
  }

  .custom-input {
    input {
      border: none !important;
    }
  }

  .table-component {
    margin: 0;
    border: none;
    margin-bottom: 160px;
    box-shadow: none;
    width: 100%;

    .button-comp {
      display: flex;
      justify-content: center;
    }

    table {
      tbody {
        td {
          max-width: 160px;
        }
      }
    }

    .btn {
      width: 70px;
      justify-content: center;
      padding: 10px 0;

      .btn--text {
        font-size: 14px;
      }
    }
  }

  .form__input {
    border: none !important;
  }

  &__configuration {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 20px;
    justify-content: flex-end;

    .btn {
      height: 50px;
    }

    .form__item {
      margin-bottom: 15px;
    }

    >div {
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
}

.custom-dropdown {
  position: relative;
  width: 100%;
  cursor: pointer;

  &__trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 58px;
    border: 1px solid #D8DADC;
    border-radius: 12px;
    background: white;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: #e00b5b;
    }

    &.active {
      border-color: #e00b5b;
      box-shadow: 0 0 0 4px rgba(224, 11, 91, 0.1);
    }
  }

  &__selected-text {
    font-size: 16px;
    color: #495255;
    font-weight: 500;
  }

  &__options {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    right: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    border: 1px solid #EAEAEA;
    z-index: 1000;
    max-height: 250px;
    overflow-y: auto;
    padding: 8px;

    /* Custom Scrollbar */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #E0E0E0;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #D0D0D0;
    }
  }

  &__option {
    padding: 12px 16px;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 15px;
    color: #495255;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background: #F8F9FA;
      color: #e00b5b;
    }

    &.selected {
      background: rgba(224, 11, 91, 0.08);
      color: #e00b5b;
      font-weight: 600;
    }
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.drop-down {
  svg {
    margin-left: 20px;
  }

  height: 59px;
  position: relative;
  min-width: 220px;
}

.dropdown-options {
  width: 100%;
}
</style>